import React from 'react'
import { Dropdown } from 'office-ui-fabric-react'

import { ChildProps, graphql } from 'react-apollo'
import {
  CampaignCollectionSummaryResponse,
  getAllCampaignCollectionSummariesQuery,
} from '../../../Api/campaigns'
import { impersonateHeaderValue } from '../../../Utils/impersonate'

interface Props {
  isDisabled: boolean
  selectedCollectionId: string
  selectedAccount: string
  onUpdated: (campaignCollection: CampaignCollection) => void
}

interface CampaignCollection {
  collectionId: string
  isPlaceholder: boolean
}

const CampaignCollectionFormView: React.FC<
  ChildProps<Props, CampaignCollectionSummaryResponse>
> = ({ onUpdated, data, selectedCollectionId, isDisabled }) => {
  const { error, loading } = data!

  if (error) {
    return <React.Fragment />
  }

  const collectionOptions = !loading
    ? data!.campaignCollections!.map((c) => ({
        text: c.title,
        key: c.id,
        data: { isPlaceholder: !!c.placeholder },
      }))
    : []
  const defaultOption = {
    text: 'Create Campaigns Collection',
    key: 'newCampaignCollection',
    data: { isPlaceholder: false },
  }

  return (
    <Dropdown
      label="Collection"
      selectedKey={selectedCollectionId}
      onChange={(evt, value?) => {
        if (!value) {
          return
        }
        onUpdated({
          collectionId: value.key.toString(),
          isPlaceholder: !!(value as any).data.isPlaceholder,
        })
      }}
      placeholder="Select a collection"
      required={true}
      options={collectionOptions.concat([defaultOption])}
      disabled={isDisabled || loading}
    />
  )
}

const withGql = graphql<Props, CampaignCollectionSummaryResponse>(
  getAllCampaignCollectionSummariesQuery,
  {
    options: ({ selectedAccount }) => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      variables: { selectedAccount },
      context: {
        headers: { impersonate: impersonateHeaderValue(selectedAccount) },
      },
    }),
  }
)

export default withGql(CampaignCollectionFormView)
